export default __webpack_public_path__ + "locales/pt-BR/FillPDFDialog.json?hash=8aec3dbd0b4e6ed7275732d74c64c290";